const options = {
  5: "bg-yellow-600/5",
  10: "bg-yellow-600/10",
  25: "bg-yellow-600/25",
  50: "bg-yellow-600/50",
  75: "bg-yellow-600/75",
  90: "bg-yellow-600/90",
  100: "bg-yellow-600",
};

const from = {
  5: "from-yellow-600/5",
  10: "from-yellow-600/10",
  25: "from-yellow-600/25",
  50: "from-yellow-600/50",
  75: "from-yellow-600/75",
  90: "from-yellow-600/90",
  100: "from-yellow-600",
};

export default function getBackgroundYellow600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
